<template>
  <div
    :class="{
      'custom-import-height': form.file.type === 'text',
      'cite-table-height': openCiteDebateTable,
      'custom-import-height-form': form.file?.name !== undefined && form.file.type !== 'text',
      'custom-import-height-loading': fileLoading || fileLoadingCite,
    }"
    class="uk-position-relative uk-margin uk-flex uk-flex-middle uk-flex-center input-file custom-import-height-defualt"
    @dragover="dragover"
    @drop="drop"
  >
    <div v-if="fileLoading || fileLoadingCite" style="z-index: 15; height: 100%; width: 100%">
      <ResourceLoadStatus
        :loading="fileLoading || fileLoadingCite"
        :layout="'horizontal'"
        :centerTop="true"
      />
    </div>
    <form-group
      class="uk-flex uk-flex-between"
      :class="{ 'uk-flex-middle': form.file.type !== 'text' }"
      style="width: 97%"
      v-else-if="form.file?.name !== undefined"
    >
      <span
        v-if="form.file.type === 'file'"
        uk-icon="icon: folder; ratio: 1.3"
        class="import-icon-styles"
      ></span>
      <span
        v-if="form.file.type === 'url' && !editMode"
        uk-icon="icon: link; ratio: 1.3"
        class="import-icon-styles"
      ></span>
      <span
        v-if="form.file.type === 'text'"
        uk-icon="icon: file-text; ratio: 1.3"
        class="import-icon-styles edit-text-box-padding"
      ></span>
      <img
        v-if="form.file.type === 'cite' && !editMode"
        src="/icons/debate-library.svg"
        height="26px"
        width="26px"
        alt=""
        class="import-icon-styles-cite"
      />
      <textarea
        v-if="form.file.type === 'text'"
        style="height: 145px"
        class="uk-textarea uk-width-1-1 focus-field past-textarea"
        type="text"
        data-tid="content-textarea"
        ref="form_text"
        v-model="form['file']['data']"
      />
      <span
        v-else-if="editMode && form.file.type !== 'url' && form.file.type !== 'cite'"
        @click="EventBus.emit('citation.preview')"
        class="fileLookLink ellipsis-link"
        :class="{ 'ellipsis-link-text': form.file.type === 'text' }"
        type="text"
      >
        {{ form['file']['name'] }}
      </span>
      <a
        v-else-if="form.file.type === 'cite' && editMode"
        target="_blank"
        :href="form['file']['name']"
        class="ellipsis-link"
      >
        <img
          v-if="form.file.type === 'cite'"
          src="/icons/debate-library.svg"
          height="26px"
          width="26px"
          alt=""
          class="import-icon-styles-cite"
        />{{ form['file']['name'] }}</a
      >
      <a
        v-else-if="form.file.type === 'url' && editMode"
        target="_blank"
        :href="form['file']['name']"
        class="ellipsis-link"
      >
        <span
          v-if="form.file.type === 'url'"
          uk-icon="icon: link; ratio: 1.3"
          class="import-icon-styles"
        ></span
        >{{ form['file']['name'] }}</a
      >
      <input
        v-else
        class="uk-input focus-field"
        :class="{
          link: form.file.data && form.file.type === 'url',
          'uk-width-1-1': form.file.type !== 'url' || form.file.data || citeDebate,
          'uk-width-3-5': !citeDebate && form.file.type === 'url' && !form.file.data,
        }"
        type="text"
        ref="form_url"
        @paste="valuePasted"
        :disabled="form.file.data"
        v-model="form['file']['name']"
      />
      <button
        v-if="form.file.type === 'url' && !form.file.data && !citeDebate"
        class="heading-action-button uk-flex uk-flex-center uk-flex-middle uk-button uk-button-secondary"
        :disabled="!form.file?.name || !url(form.file?.name)"
        type="button"
        @click="EventBus.emit('citation.extractArticle')"
        style="margin-left: 15px; height: auto"
      >
        <span
          :uk-tooltip="`Press here to extract data`"
          class="uk-text-bolder uk-margin-small-left"
          v-text="`EXTRACT DATA`"
        />
      </button>
      <span
        v-if="formConfig ? formConfig.documentType.editable !== false : true"
        uk-icon="icon: ban;ratio:1.3"
        @click="$emit('handleDocumentType', form.documentType)"
        class="close-icon"
        :class="{ 'edit-text-box-padding': form.file.type === 'text' }"
      ></span>
    </form-group>
    <div v-else-if="openCiteDebateTable" class="width-max-cite">
      <button class="table-close" @click="openDebateTable()" uk-icon="close"></button>
      <PrimeDataTable
        ref="titleDataTable"
        :tableConfig="tableCiteDebateConfig"
        :tableOptions="tableCiteDebateOptions"
        :loadDataFunction="getDebateList"
        :pagination="false"
        :columnChooser="false"
        :scrollable="true"
        scrollHeight="230px"
      />
    </div>
    <div class="uk-flex uk-flex-middle" v-else>
      <button
        class="heading-action-button uk-flex uk-flex-center uk-flex-middle uk-button uk-button-muted uk-padding-small"
        type="button"
        @click="handleDocument('url')"
        style="margin: 0 15px; box-shadow: 0px 4px 4px 0px #516d79"
      >
        <span uk-icon="icon: link; ratio: 1.3" style="color: black"></span>
        <span
          :uk-tooltip="`Press here to import an online document`"
          class="uk-text-bolder uk-text-emphasis uk-margin-small-left"
          v-text="`PASTE LINK`"
        />
      </button>

      <span v-if="showOr" class="uk-text-emphasis">― OR ―</span>
      <button
        type="button"
        class="heading-action-button uk-flex uk-flex-center uk-flex-middle uk-button uk-button-muted uk-padding-small"
        data-tid="paste-text"
        @click="handleDocument('text')"
        style="margin: 0 15px; box-shadow: 0px 4px 4px 0px #7cb6c9"
      >
        <span uk-icon="icon: file-text; ratio: 1.3" style="color: black"></span>
        <span
          :uk-tooltip="`Press here to paste the text`"
          class="uk-text-bolder uk-text-emphasis uk-margin-small-left"
          v-text="`PASTE TEXT`"
        />
      </button>

      <span v-if="showOr" class="uk-text-emphasis">― OR ―</span>

      <button
        type="button"
        class="heading-action-button uk-flex uk-flex-center uk-flex-middle uk-button uk-button-muted uk-padding-small"
        @click="handleDocument('file')"
        style="margin: 0 15px; box-shadow: 0px 4px 4px 0px #ebbb8b"
      >
        <span uk-icon="icon: folder; ratio: 1.3" style="color: black"></span>
        <span
          :uk-tooltip="`Press here to browse for a document`"
          class="uk-text-bolder uk-text-emphasis uk-margin-small-left"
          v-text="`DROP FILE`"
        />
      </button>
      <button
        v-if="citeDebate"
        type="button"
        class="heading-action-button uk-flex uk-flex-center uk-flex-middle uk-button uk-button-muted uk-padding-small"
        @click="openDebateTable"
        style="margin: 0 15px; box-shadow: 0px 4px 4px 0px #d9a5ae"
      >
        <img src="/icons/debate-library.svg" height="26px" width="26px" alt="" />
        <span
          :uk-tooltip="`Press here to Cite Debate`"
          class="uk-text-bolder uk-text-emphasis uk-margin-small-left"
          v-text="`CITE DEBATE`"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import ResourceLoadStatus from '@/components/general/ResourceLoadStatus';
import { url } from '@vuelidate/validators';
import { xhr } from '@/xhr/endpoints';
import { EventBus } from '@/assets/js/event-bus';
import { mapGetters } from 'vuex';
import UIkit from 'uikit';
export default {
  name: 'CustomImport',
  props: {
    citeDebate: Boolean,
    form_prop: Object,
    showOr: {
      typr: Boolean,
      default: true,
    },
    formConfig: {
      type: Object,
      default: null,
    },
    fileLoadingCite: {
      type: Boolean,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ResourceLoadStatus,
    PrimeDataTable: defineAsyncComponent(() => import('@/components/table/PrimeDataTable.vue')),
  },
  data() {
    return {
      fileLoading: false,
      form: this.form_prop,
      type: '',
      documentOwnersNames: [],
      pastText: false,
      openCiteDebateTable: false,
      editedMode: false,
    };
  },
  watch: {
    'form.file.name': {
      handler(value) {
        this.form.url = value;
      },
    },
    'form.file.data': {
      handler(value) {
        if (this.type === 'text') {
          EventBus.emit('form.file.data.changes', value);
          this.form.url = value;
        }
      },
    },
    form_prop(value) {
      this.form = value;
    },
  },
  mounted() {
    EventBus.on('citatiom.mode.model', this.citatiomModeModel);
  },
  beforeUnmount() {
    EventBus.off('citatiom.mode.model', this.citatiomModeModel);
  },
  computed: {
    ...mapGetters(['userId']),
    url() {
      return url;
    },
    UIkit() {
      return UIkit;
    },
    EventBus() {
      return EventBus;
    },
    tableCiteDebateOptions() {
      return {
        globalFilterFields: ['title', 'author', 'articleTitle'],
        placeHolderData: true,
        tableName: 'debateList2',
      };
    },

    tableCiteDebateConfig() {
      const tableConfig = [
        {
          column: 'Debate Title',
          field: 'title',
          model: row => {
            return row.title;
          },
          action: row => this.setValueInForm(row),
          sortable: true,
          ellipsis: true,
        },
        {
          column: 'Article Author',
          field: 'author',
          model: row => {
            return row.author;
          },
          filter: {
            type: 'select',
            options: [...this.documentOwnersNames],
          },
          sortable: true,
        },
        {
          column: 'Content Title',
          field: 'articleTitle',
          model: row => {
            return row.articleTitle;
          },
          sortable: true,
          ellipsis: true,
        },
      ];
      return tableConfig;
    },
  },
  methods: {
    async getDebateList({ page, sortColumn, sortDirection, filters }) {
      this.debateList = await xhr.getDebateList(
        this.userId,
        page,
        sortColumn,
        sortDirection,
        filters
      );
      this.documentOwnersNames = [];
      if (filters?.archived?.value) {
        this.debateList.debateList.map(item => {
          if (!this.documentOwnersNames.includes(item.author))
            this.documentOwnersNames.push(item.author);
        });
      } else {
        this.debateList.debateList.map(item => {
          if (!this.documentOwnersNames.includes(item.author))
            this.documentOwnersNames.push(item.author);
        });
      }
      this.debateList.debateList = this.debateList.debateList.filter(
        debate => debate.privacy !== 'Private'
      );
      return this.debateList;
    },
    dragover(event) {
      event.preventDefault();
    },
    setValueInForm(data) {
      this.openCiteDebateTable = false;
      this.handleDocument('cite', data.id);
      this.form.title = data.title;
      UIkit.dropdown(this.$refs.dropModalCiteDebate).hide();
    },
    drop(event) {
      event.preventDefault();
      if (event.dataTransfer.getData('URL')) {
        this.handleDocument('url');
        this.form.file.name = event.dataTransfer.getData('URL');
      } else {
        this.readDocument(event.dataTransfer.files);
      }
    },
    openDebateTable() {
      this.openCiteDebateTable = !this.openCiteDebateTable;
    },
    citatiomModeModel(mode, cite) {
      if (mode === 'edit') {
        setTimeout(() => {
          this.form.file.data = cite.content;
        }, 200);
      }
    },
    handleDocument(type, id) {
      this.type = type;
      if (type === 'text') {
        this.pastText = true;
      } else {
        this.pastText = false;
      }
      if (type === 'file') {
        let input = document.createElement('input');
        input.type = 'file';
        input.accept = '.txt,.doc,.docx';
        input.onchange = () => {
          this.readDocument(input.files);
        };
        input.click();
        setTimeout(() => {
          document.querySelector('.label-focus-field')?.focus();
        }, 300);
      } else if (type === 'url' || type === 'text') {
        setTimeout(() => {
          document.querySelector('.focus-field')?.focus();
        }, 300);
        this.form.file = {
          name: '',
          data: null,
          type,
        };
        this.$nextTick(() => {
          const form_field = this.$refs[type === 'url' ? 'form_url' : 'form_text']?.[0];
          if (form_field) form_field?.focus();
        });
      } else if (type === 'cite') {
        this.form.file = {
          name: `${window.location.origin}/#/debate/${id}`,
          data: null,
          type,
        };
        this.$nextTick(() => {
          const form_field = this.$refs[type === 'cite' ? 'form_url' : 'form_text']?.[0];
          if (form_field) form_field?.focus();
        });
      }
    },
    valuePasted() {
      setTimeout(() => {
        document.querySelector('.label-focus-field')?.focus();
      }, 300);
    },

    // readDocument(data) {
    //   this.fileLoading = true
    //   let files = Array.from(data);
    //   if (files.length) {
    //     this.form.url = files[0].name
    //     this.form.file = {
    //       name: files[0].name,
    //       data: files[0],
    //       type: 'file'
    //     }
    //     this.fileLoading = false;
    //   } else this.fileLoading = false
    // },

    async readDocument(data) {
      if (this.citeDebate) {
        this.fileLoading = true;
        let files = Array.from(data);
        if (files.length) {
          this.form.url = files[0].name;
          this.form.file = {
            name: files[0].name,
            data: files[0],
            type: 'file',
          };
          this.fileLoading = false;
        } else this.fileLoading = false;
      } else {
        let files = Array.from(data);
        let test = new FormData();
        test.append('file', files[0]);
        const res = await xhr.basisUpload(test);

        this.fileLoading = true;
        if (res) {
          this.form.url = res.filename;
          this.form.file = {
            name: res.filename,
            data: res.content !== null ? res.content : res.file_text,
            type: 'file',
          };
          this.fileLoading = false;
        } else this.fileLoading = false;
      }
    },
  },
};
</script>

<style lang="sass">
.heading-action-button
  z-index: 1
  border-radius: 4px !important
  height:50px
.input-file
  width: 100%
  background: rgb(248, 248, 248)
  border-radius: 4px
  box-shadow: inset 0 0 5px #516d79
  border: 3px dashed #516d79
.uk-input
  border: 2px solid #516d79 !important
.close-icon
  color: #800020 !important
  margin-left: 10px !important
  cursor: pointer

.width-max-cite
  position: relative
  max-width: 95% !important
  width: 95%
  outline: 3px solid #254858
  padding: 5px !important
  max-height: 300px
  border-radius: 12px
.ellipsis-link
  overflow: hidden
  word-break: break-all
  text-overflow: ellipsis
  -webkit-line-clamp: 1
  display: -webkit-box
  -webkit-box-orient: vertical
  width: 90%
  &-text
    -webkit-line-clamp: 3 !important
.cite-table-height
  height: 340px !important
.custom-import-height
  height: 165px !important
  &-form
    height: 60px !important
  &-loading
    height: 60px !important
  &-defualt
    height: 100px

.import-icon-styles
  color: black !important
  margin-right: 5px !important
  &-cite
    padding-right: 5px !important
.edit-text-box-padding
  padding-top: 7px !important
</style>
